import React, { useState, useEffect } from "react";
import styled from "styled-components";

import { fetchComplexranking } from './api'
import { connect } from 'react-redux'
import { jumpTo } from '@/utils'
import paiming1 from './image/paiming1.png';
import paiming2 from './image/paiming2.png';
import paiming3 from './image/paiming3.png';
import Header from "@/components/Header";
// import bridge from '@/config/JSbridge'
import bwmodel from '@/config/bwmodel';
import moment from 'moment';
import bgd3 from './imgs/user.png'
import { handleUploadTrace } from "@/utils";

const isStorm = bwmodel.app === 'storm';
const isAfterJanuary = moment().isAfter(moment("2025-02-01"));

const Delivery = ({props,userId, token}) => {  
  const [userlist, setUserList] = useState([]);
  const [isCurrent, setIsCurrent] = useState(true);
  useEffect(()=> {
      handleUploadTrace('Million_RevenueList_Exposure', 'visitor')
    getComplexRankList();
  },[isCurrent])
  // const stockRank = 10;

  function getComplexRankList() {
    var today = new Date();
    var currentDate = new Date(today.getFullYear(), today.getMonth(), 1);
    var lastMonthdate = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
    const firstDay = isCurrent?currentDate:lastMonthdate;
 
    const statisticsDate = moment(firstDay).format('YYYY-MM-DD')

    const params = {
      "category": 1,
      "pageNo": 1,
      "pageSize":50,
      "statisticsDate": statisticsDate,
      "stockCode": "3"
    }
    fetchComplexranking(params)
      .then(res => {
        setUserList(res.data)
      })
  }
  function setCurrent() {
    
    const bool = !isCurrent;
    setIsCurrent(bool);
    // getComplexRankList();
  }
  return (
  <React.Fragment>
   
     {
        isStorm && <Header   
        title={'优秀创作者'}
        right={
          isAfterJanuary && <div 
            onClick={() => setCurrent()}
          >
            {isCurrent === true ? '上期榜单': '本期'} 
          </div>
        }
        />
      }
    <MoodsBox>
       <div className='title'>排行每日更新，最终结算后前20创作者将得奖励</div>
      <div className='create_box'>
          <div className='create_header'>
            <div>名次</div>
            <div>创作分</div>
          </div>

          {
            userlist.map((item,index)=> {
              return (
                <div className='create_item' > 
                  <div className='create_item_left'>{index>2?index+1:''}</div>
                  <div className='create_item_right'>
                    <div className='item_right_title'
                      onClick={()=> {
                        jumpTo(`storm://app/userzone?userID=${item.author.userId}&userName=${item.author.nickname}`)
                      }}
                    >
                      {/* <div className='avatar1'>
                        <img src={item.author.avatar}  alt=""/>
                      </div> */}
                      <div class="avatar-wrapper">
                        <img src={item.author.avatar } alt="Avatar" class={ item.author.originalFlag ? 'avatar-original avatar' : 'avatar' }/>
                        {
                          item.author.originalFlag &&  <div class="avatar-frame"></div>
                        }
                        
                      </div>

                      <div className='name'>
                        {item.author.nickname}
                         {
                          item.author.originalFlag &&   <img src={require('./imgs/Group.png')} alt=""/>
                         }
                      
                        </div> 
                      <div>{item.hot}</div>
                    </div>
                    <div className='content'
                      // contentId
                      onClick={()=> {
                        // 
                        if(item.contentType === 'moment') {
                          jumpTo(`${process.env.REACT_APP_WOGOO_URL}/essay/#/community?momentsId=${item.contentId}&location=undefined`)
                      
                        } else {
                          jumpTo(`${process.env.REACT_APP_WOGOO_URL}/essay/#/?articleId=${item.contentId}`)
                      
                        }
                      }}
                    >
                      <span>代表作：</span>
                      <b 
                        onClick={(event)=> {
                          event.stopPropagation();
                         
                           jumpTo(`storm://app/stock/detail?stockcode=${item.stockCode}&tab=topic&scrollTop=1`)
                        }}
                      >讨论${item.stockName}$</b>
                      <p>{item.introduce}</p>
                      {/* {item.introduce.replace(/\$\s*([^$]+)\$ /g, '讨论$ $1 $\n')} */}
                    </div>
                  </div>
                </div>
              )
            })
          }
        
      </div>
     
    </MoodsBox>
    </React.Fragment>
  )
}

// export default React.memo(forwardRef(Delivery));
const mapStateToProps = (state) => {
  // console.log(state);
  return {
    token: state.user.accessToken || '',
    userId: state.user.userId
  }
}

export default React.memo(connect(mapStateToProps)(Delivery));
export const MoodsBox = styled.div`
  position: relative;
  background: linear-gradient(0deg, #F7D9B8 0%, #F7D9B8 100%);
  min-height: 100vh;
  padding-top: 64px;
  padding-bottom: 30px;
  .title {
    text-align: center;
    font-size: 14px;
    color: #000000;
  }
  .create_box {
    margin: 12px 12px 0 12px;
    padding: 14px;
    background-color:#FFF9F3;
    border-radius: 10px;
  }
  .create_header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    font-size: 12px;
    color: #000;
  }
  
   .create_item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    &:nth-child(2) {
      .create_item_left{
         background-image: url(${paiming1});
      }
    }
    &:nth-child(3) {
      .create_item_left{
         background-image: url(${paiming2});
      }
    }
    &:nth-child(4) {
      .create_item_left{
         background-image: url(${paiming3});
      }
    }
    .create_item_left {
      font-weight: bolder;
      font-size: 16px;
      color: #000000;
      line-height: 23px;
      width: 30px;
      flex-shrink:0;
      text-align: center;
      background-size: 100%;
      background-repeat: no-repeat;
    }
    
    .create_item_right {
      flex: 1;
      font-weight: bold;
      font-size: 14px;
      overflow: hidden;
    }
    .item_right_title {
      display: flex;
      justify-content:space-between;
      height: 23px;
      color: #000000;
      align-items: center;
      .name {
        flex: 1;
        text-align: left;
        padding: 0 10px;
        display: flex;
        align-items: center;
        img {
          margin-left: 5px;
          height: 15px;
        }
      }
      .avatar1 {
        margin-left: 2px;
        vertical-align: middle;
        img {
          width: 20px;
          height: 20px;
          border-radius: 10px;
        }
      }
      .avatar-wrapper {
        position: relative;
        width: 20px;
        height: 20px;
        margin: 0 auto;
        transition: transform 0.4s ease;
      }

      .avatar-wrapper:hover {
        transform: scale(1.1);
      }

      .avatar-frame {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url(${bgd3}); /* 边框图片 */
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        z-index: 2;
        pointer-events: none;
      }

      .avatar {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%; /* 调整头像大小 */
        height: 100%; /* 调整头像大小 */
        border-radius: 50%;
        object-fit: cover;
        z-index: 1;
        border: 3px solid white;
        background: #FFC45D;
        &.avatar-original {
          width: 80%; /* 调整头像大小 */
          height: 80%; /* 调整头像大小 */
        }
        // box-shadow: 0 5px 15px rgba(0,0,0,0.3);
      }
    }
    .content {
      margin-top: 7px;
      background: #F7D9B8;
      border-radius: 5px;
      color: #000;
      padding: 10px 8px;
      font-size: 11px;
      line-height: 15px;
       width: 100%;
      box-sizing: border-box;
      span {
        color: #C63711;
        font-weight: bold;
      }
      p {
        padding: 0;
        margin: 5px 0 0 0;
        white-space: nowrap; /* 防止文本换行 */
        overflow: hidden;    /* 隐藏溢出的文本 */
        text-overflow: ellipsis; /* 溢出部分用省略号表示 */
        width: 100%;
        box-sizing: border-box;
      }
    }
  }
     
`;



// WEBPACK FOOTER //
// ./src/views/activity_130/content.js